// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"b92d3464","692":"48e590e3"}[chunkId] + ".chunk.css";
};